export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";